/**
 * Adapted from Feather Icons "map" (https://feathericons.com, ISC license),
 * rescaled to the 16x16 grid.
 */
export function MapIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      aria-label="Map"
      focusable="false"
    >
      <path
        d="M1.5 4V14.5L6 12L10 14.5L14.5 12V1.5L10 4L6 1.5L1.5 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 1.5V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4V14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
